module.exports = require('./helpers/bundle-url').getBundleURL('geQvc') + "stripe-terminal-verifone-default-splash.fb1fdd3d.png";